var URI = {
	init: function() {
		let wh = window.location.href;
		let ac: any = wh.split('#/');
		let action: string = 'servicos/cidadao';

		console.log(action);

		if (typeof ac[1] != 'undefined' && ac[1]) {
			action = ac[1];
		}

		URI.exec(action);
		URI.selectMenu(action);
	},

	change: function() {
		var wh = window.location.href;
		var ac = wh.split('#/');

		if (typeof ac[1] !== 'undefined') {
			URI.selectMenu(ac[1]);
			URI.exec(ac[1]);
		}
	},

	exec: function(ac: any, title: any = null) {
		$('#content').html('').addClass('content-loading');
		$.post('/load', { action: ac }, function(r) {
			$('#content').html(r).removeClass('content-loading');
		});
	},

	selectMenu: function(ac: any) {
		var dd = ac.split('/');

		//Nao esta sendo utilizado
		// if (dd[0] === 'servicos') {
		// 	$(`.h-card-tipo`).removeClass('h-card-tipo-selected');
		// 	$(`#h-card-tipo-${dd[1]}`).addClass('h-card-tipo-selected');
		// }
	}
};

window.onhashchange = function() {
	// URI.change();
	// $('html, body').animate(
	// 	{
	// 		scrollTop: $('#content').offset().top
	// 	},
	// 	900
	// );
	// $('body, html').animate({ scrollTop: 0 }, 900);
};
